import { useTranslation } from 'components/lib';

import { Fab, Tooltip } from '@mui/material';


export function ChallengeInfoFloat(props) {
    
    const { t } = useTranslation();
    return (
        <>
            <Tooltip title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.floatingInfo.testCase')}>
                <Fab
                    id='testCasesFAB'
                    variant="extended"
                    disableRipple
                    disableFocusRipple
                    sx={{
                        // bgcolor: amber[500],
                        background: "linear-gradient(to right, #ffecb3ba, #ffe082ba, #ffd54fba, #ffca28ba, #ffc107ba)",
                        display: 'flex',
                        width: "42px",
                        fontWeight: 700,
                        fontSize: "larger",
                        color: "rgba(0, 0, 0, 0.55)",
                        mr: "4px",
                        cursor: "default"
                    }}
                >
                    {props.numTestUncovered}
                </Fab >
            </Tooltip>
            <Tooltip title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.floatingInfo.attempts')}>
                <Fab
                    disableRipple
                    disableFocusRipple
                    id='attemptsFAB'
                    variant="extended"
                    sx={{
                        background: "linear-gradient(to right, #ef9a9aba, #e57373ba, #ef5350ba, #e53935ba)",
                        display: 'flex',
                        width: "42px",
                        fontWeight: 700,
                        fontSize: "larger",
                        color: "rgba(0, 0, 0, 0.55)",
                        mr: "4px",
                        cursor: "default"
                    }}
                >
                    {props.attemptsExceeded
                        ? props.attempts
                        : props.currentAttempts}
                </Fab >
            </Tooltip>
            <Tooltip title={t('Streams.ChallengeLevelOne.ChallengeLevelOne.floatingInfo.coverage')}>
                <Fab
                    disableRipple
                    disableFocusRipple
                    id='progressFAB'
                    variant="extended"
                    sx={{
                        background: "linear-gradient(to right, #80cbc4ba, #4db6acba, #26a69aba, #009688ba)",
                        display: 'flex',
                        width: "42px",
                        fontWeight: 700,
                        fontSize: "large",
                        color: "rgba(0, 0, 0, 0.55)",
                        cursor: "default"
                    }}
                >
                    {props.progressPercent}%
                </Fab >
            </Tooltip>
        </>
    );
}